webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_About__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Works__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Works___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Works__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Milestones__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Milestones___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Milestones__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_About___default.a
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_2__components_About___default.a
  }, {
    path: '/works',
    name: 'Works',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Works___default.a
  }, {
    path: '/milestones',
    name: 'Milestones',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Milestones___default.a
  }]
}));

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(11)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(21),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(2);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about',
  data: function data() {
    return {};
  },

  methods: {
    scroll: function scroll() {
      var el = document.getElementById('links');
      if (el) {
        window.scrollTo(window.scrollX, el.offsetTop);
      }
    }
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'works',
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'WorkImages',
  computed: {
    pages: function pages() {
      var pages = [];
      for (var i = 0; i < this.images.length; i++) {
        pages.push(i);
      }
      return pages;
    },
    mainImage: function mainImage() {
      return this.images[this.currentImage];
    }
  },
  data: function data() {
    return {
      currentImage: 0,
      showLightbox: false
    };
  },

  methods: {
    goLeft: function goLeft() {
      if (this.currentImage - 1 >= 0) {
        this.currentImage--;
      } else {
        this.currentImage = this.images.length - 1;
      }
    },
    goRight: function goRight() {
      if (this.currentImage + 1 < this.images.length) {
        this.currentImage++;
      } else {
        this.currentImage = 0;
      }
    }
  },
  props: {
    images: {
      type: Array,
      required: true
    }
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WorkImages__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WorkImages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__WorkImages__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    WorkImages: __WEBPACK_IMPORTED_MODULE_0__WorkImages___default.a
  },
  name: 'works',
  data: function data() {
    return {
      works: [{
        title: 'Hostly',
        genre: 'Vacation Rental Software',
        description: 'Hostly is a cloud based property management software that enables vacation rental owners and property managers to save their time, and spend more energy on building better relations with their customers.',
        skills: ['Ruby on Rails', 'Vue.js', 'Ruby', 'ES7', 'Browserify', 'Wercker'],
        isPublished: false,
        link: null,
        images: ['/static/Hostly01.png', '/static/Hostly02.png', '/static/Hostly03.png', '/static/Hostly04.png', '/static/Hostly05.png', '/static/Hostly06.png', '/static/Hostly07.png', '/static/Hostly08.png'],
        role: 'Product Owner. Tech Lead.'
      }, {
        title: 'Portfolio',
        genre: 'Website',
        description: 'To showcase my profile, skills, and experiences to the world. I just wanted a sandbox to mess with new technologies.',
        skills: ['Vue.js', 'vue-cli', 'vue-router', 'ES7', 'Webpack', 'GitHub Pages'],
        isPublished: false,
        link: 'https://andoshin11.github.io/',
        images: ['/static/portfolio01.png', '/static/portfolio02.png'],
        role: 'Personal Project'
      }, {
        title: 'Random Pocket',
        genre: 'Slack Bot',
        description: 'Post random articles from Pocket archives to a Slack channel every 12 hours',
        skills: ['Google Apps Script', 'Pocket API', 'Slack API'],
        isPublished: false,
        link: null,
        images: ['/static/pocket01.png'],
        role: 'Personal Project'
      }, {
        title: 'gig 360°',
        genre: 'Hackathon Product',
        description: 'gig 360° is a community where Music Lovers share their exciting moments by posting live 360 streaming videos. Award winning product at AngelHack Osaka 2017.',
        skills: ['Ruby on Rails', 'Vue.js', 'Ruby', 'ES7', 'Browserify'],
        isPublished: false,
        link: 'http://www.hackathon.io/83831',
        images: ['/static/gig01.png', '/static/gig02.png', '/static/gig03.png', '/static/gig04.png', '/static/gig05.png'],
        role: 'Personal Project'
      }, {
        title: 'Airbnb Crawler',
        genre: 'Data Analysis Script',
        description: 'Python script to crawl Airbnb and collect vacation rental business data.',
        skills: ['Python', 'BeautifulSoup', 'Tableau'],
        isPublished: false,
        link: 'https://goo.gl/5HZUTo',
        images: ['/static/scrape01.png', '/static/scrape02.png', '/static/scrape03.png', '/static/scrape04.png', '/static/scrape05.png'],
        role: 'Personal Project'
      }, {
        title: 'Cloud Miner',
        genre: 'Bitcoin mining tool / Hackathon Product',
        description: 'Cloud mining tool works on browsers. Using JavaScipt and WebGL, this tool caliculates millions of SHA256 Hash on client machines to find a nonce for the new block. The results will be sent to the central server for validation.',
        skills: ['Ruby on Rails', 'Vue.js', 'Ruby', 'ES7', 'Browserify', 'SHA256'],
        isPublished: false,
        link: null,
        images: ['/static/bitcoin01.gif', '/static/bitcoin02.png'],
        role: 'Personal Project'
      }, {
        title: 'CINELOG',
        genre: 'Movie Diary Application',
        description: 'Personal dialy to keep all the good memories with fantastic films.',
        skills: ['Ruby on Rails', 'Vue.js', 'Ruby', 'ES7', 'Browserify', 'OAuth2', 'The Movie Database API', 'Twitter API'],
        isPublished: false,
        link: null,
        images: ['/static/cinelog01.png', '/static/cinelog02.gif'],
        role: 'Personal Project'
      }]
    };
  },

  methods: {}
});

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/profile.3283734.jpg";

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(13)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(23),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-53f92474",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(14)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(24),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7e0e5aac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(12)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(22),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-50c8c792",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(10)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(20),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3443cc2e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "works"
  }, _vm._l((_vm.works), function(work) {
    return _c('div', {
      staticClass: "work"
    }, [_c('div', {
      staticClass: "work__title"
    }, [_vm._v(_vm._s(work.title))]), _vm._v(" "), _c('div', {
      staticClass: "work__genre"
    }, [_vm._v(_vm._s(work.genre))]), _vm._v(" "), _c('WorkImages', {
      attrs: {
        "images": work.images
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "work__description"
    }, [_vm._v(_vm._s(work.description))]), _vm._v(" "), (!work.link) ? _c('div', {
      staticClass: "work__private"
    }, [_vm._v("# Private Project")]) : _vm._e(), _vm._v(" "), (work.link) ? _c('a', {
      staticClass: "work__link",
      attrs: {
        "href": work.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(work.link))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "work__skills skills"
    }, _vm._l((work.skills), function(skill) {
      return _c('span', {
        staticClass: "skills__skill"
      }, [_vm._v(_vm._s(skill))])
    }))], 1)
  }))
},staticRenderFns: []}

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header__title"
  }, [_vm._v("SHIN ANDO")]), _vm._v(" "), _c('div', {
    staticClass: "header__nav"
  }, [_c('a', {
    staticClass: "header__nav__link",
    attrs: {
      "href": "/#/about"
    }
  }, [_vm._v("ABOUT")]), _vm._v(" "), _c('a', {
    staticClass: "header__nav__link",
    attrs: {
      "href": "/#/works"
    }
  }, [_vm._v("WORKS")])])])
}]}

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "images"
  }, [_c('div', {
    staticClass: "images__left",
    on: {
      "click": function($event) {
        _vm.goLeft()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "images__main",
    on: {
      "click": function($event) {
        _vm.showLightbox = true
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.mainImage,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "images__right",
    on: {
      "click": function($event) {
        _vm.goRight()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "lightbox"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLightbox),
      expression: "showLightbox"
    }],
    staticClass: "lightbox"
  }, [_c('div', {
    staticClass: "lightbox-body"
  }, [_c('div', {
    staticClass: "lightbox-body__close",
    on: {
      "click": function($event) {
        _vm.showLightbox = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "lightbox-body__left",
    on: {
      "click": function($event) {
        _vm.goLeft()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "lightbox-body__image"
  }, [_c('img', {
    attrs: {
      "src": _vm.mainImage,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "lightbox-body__right",
    on: {
      "click": function($event) {
        _vm.goRight()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about"
  }, [_c('div', {
    staticClass: "introduction"
  }, [_c('img', {
    staticClass: "introduction__image",
    attrs: {
      "src": __webpack_require__(15),
      "alt": "profile"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "introduction__content"
  }, [_c('strong', [_vm._v("I")]), _vm._v("am a Japanese software engineer / tech geek / history nerd / future astronaut. As I grew up in multiple communities in multiple cities (7 cities in 3 countries, to be exact!), I realized that this world is one huge Cultural Mosaic. Billions of people have Billions of different stories behind. Now, it's time to write the story of my life."), _c('br'), _c('br'), _vm._v("What does your story look like? "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scroll()
      }
    }
  }, [_vm._v("Share them with me!")]), _vm._v(" I'm always looking for a key to open the next door.\n    ")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('div', {
    staticClass: "profile__header about__header"
  }, [_vm._v("PROFILE")]), _vm._v(" "), _c('div', {
    staticClass: "profile__label"
  }, [_vm._v("Date of Birth:")]), _vm._v(" "), _c('div', {
    staticClass: "profile__content"
  }, [_vm._v("21/10/1992")]), _vm._v(" "), _c('div', {
    staticClass: "profile__label"
  }, [_vm._v("Sex:")]), _vm._v(" "), _c('div', {
    staticClass: "profile__content"
  }, [_vm._v("Male")]), _vm._v(" "), _c('div', {
    staticClass: "profile__label"
  }, [_vm._v("Belief:")]), _vm._v(" "), _c('div', {
    staticClass: "profile__content"
  }, [_vm._v("Christian (Baptist)")]), _vm._v(" "), _c('div', {
    staticClass: "profile__label"
  }, [_vm._v("Location:")]), _vm._v(" "), _c('div', {
    staticClass: "profile__content"
  }, [_vm._v("Sapporo, Hokkaido, Japan")]), _vm._v(" "), _c('div', {
    staticClass: "profile__content"
  }, [_vm._v("Asahikawa, Hokkaido, Japan")]), _vm._v(" "), _c('div', {
    staticClass: "profile__content"
  }, [_vm._v("Munich, Germany")]), _vm._v(" "), _c('div', {
    staticClass: "profile__content"
  }, [_vm._v("Tokyo, Japan")]), _vm._v(" "), _c('div', {
    staticClass: "profile__content"
  }, [_vm._v("Kushiro, Hokkaido, Japan")]), _vm._v(" "), _c('div', {
    staticClass: "profile__content"
  }, [_vm._v("Columbus, Ohio, USA")]), _vm._v(" "), _c('div', {
    staticClass: "profile__content"
  }, [_vm._v("Kyoto, Japan")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "skills"
  }, [_c('div', {
    staticClass: "skills__header about__header"
  }, [_vm._v("SKILLS")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Ruby")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Ruby on Rails")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Firebase")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Heroku")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("PHP")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Wordpress")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Perl")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Python")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("ES8")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("React")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Vue.js")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("MySQL")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("PostgreSQL")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Docker")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Hadoop")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Linux")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Git")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("HTML5")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("CSS3")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("jQuery")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Google Apps Script")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "links",
    attrs: {
      "id": "links"
    }
  }, [_c('div', {
    staticClass: "links__header about__header"
  }, [_vm._v("LINKS")]), _vm._v(" "), _c('a', {
    staticClass: "links__link",
    attrs: {
      "href": "https://github.com/andoshin11",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "links__link",
    attrs: {
      "href": "https://www.linkedin.com/in/shin-ando-95193972/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin-square",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "links__link",
    attrs: {
      "href": "https://www.instagram.com/andoshin11/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "links__link",
    attrs: {
      "href": "https://twitter.com/andoshin11",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "links__link",
    attrs: {
      "href": "https://www.facebook.com/andoshin11",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook-official",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "links__link",
    attrs: {
      "href": "http://www.justyo.co/ANDOSHIN11/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-square",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "links__link",
    attrs: {
      "href": "mailto:shinglish11@gmail.com"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "links__link",
    attrs: {
      "href": "https://www.amazon.co.jp/gp/registry/wishlist/1GOD9AV7NRYPZ/ref=nav_wishlist_lists_1",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-amazon",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
}]}

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "milestones"
  }, [_c('div', {
    staticClass: "milestones__header"
  }, [_vm._v("Significant events in my journey")]), _vm._v(" "), _c('div', {
    staticClass: "milestone"
  }, [_c('div', {
    staticClass: "milestones__title"
  }, [_vm._v("Portfolio")]), _vm._v(" "), _c('div', {
    staticClass: "milestones__description"
  }, [_vm._v("To showcase my profile, skills, and experiences to the world, and to mess with new new technologies.")]), _vm._v(" "), _c('a', {
    staticClass: "milestones_link",
    attrs: {
      "href": "https://andoshin11.github.io/",
      "target": "_blank"
    }
  }, [_vm._v("https://andoshin11.github.io/")]), _vm._v(" "), _c('div', {
    staticClass: "milestones__skills skills"
  }, [_c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("ES6")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("Vue.js")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("vue-cli")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("vue-router")]), _vm._v(" "), _c('span', {
    staticClass: "skills__skill"
  }, [_vm._v("GitHub Pages")])]), _vm._v(" "), _c('div', {
    staticClass: "work__images"
  })])])
}]}

/***/ })
],[4]);


// WEBPACK FOOTER //
// static/js/app.2b781d70e26af10bf9ad.js